module.exports = __webpack_public_path__ + "static/media/graphql-og.1a050b84.svg";